// import React from "react";
// import "../../../../../../css/pages/ca_pages/finances/models/client_payments_model/PaymentDetailsSection.css";

import React from "react";

const PaymentDetailsSection = ({
    form,
    errors,
    onChange,
}) => {
    return (
        <section className="payment-form-section">
            <div className="section-heading">
                <h3>Payment Details</h3>

                <span>
                    Configure the amount and payment
                    deadline.
                </span>
            </div>

            <div className="form-grid">
                {/* TITLE */}

                <div className="form-group">
                    <label>
                        Payment Title
                        <span className="required-mark">
                            *
                        </span>
                    </label>

                    <input
                        type="text"
                        name="title"
                        value={form.title}
                        onChange={onChange}
                        placeholder="e.g. GST Filing Services"
                        className={
                            errors.title
                                ? "input-error"
                                : ""
                        }
                    />

                    {errors.title && (
                        <small className="field-error">
                            {errors.title}
                        </small>
                    )}
                </div>

                {/* AMOUNT */}

                <div className="form-group">
                    <label>
                        Amount
                        <span className="required-mark">
                            *
                        </span>
                    </label>

                    <div
                        className={`amount-input ${
                            errors.amount
                                ? "input-error"
                                : ""
                        }`}
                    >
                        <span>₹</span>

                        <input
                            type="number"
                            name="amount"
                            value={form.amount}
                            onChange={onChange}
                            placeholder="25,000"
                            min="0"
                            step="0.01"
                        />
                    </div>

                    {errors.amount && (
                        <small className="field-error">
                            {errors.amount}
                        </small>
                    )}
                </div>

                {/* DUE DATE */}

                <div className="form-group">
                    <label>
                        Due Date
                        <span className="required-mark">
                            *
                        </span>
                    </label>

                    <input
                        type="date"
                        name="due_date"
                        value={form.due_date}
                        onChange={onChange}
                        className={
                            errors.due_date
                                ? "input-error"
                                : ""
                        }
                    />

                    {errors.due_date && (
                        <small className="field-error">
                            {errors.due_date}
                        </small>
                    )}
                </div>

                {/* CURRENCY */}

                <div className="form-group">
                    <label>
                        Currency
                    </label>

                    <select
                        name="currency"
                        value="INR"
                        disabled
                    >
                        <option value="INR">
                            INR - Indian Rupee
                        </option>
                    </select>

                    <small className="field-help">
                        Multi-currency payments will
                        be available in a future
                        update.
                    </small>
                </div>
            </div>

            {/* DESCRIPTION */}

            <div className="form-group">
                <label>
                    Description
                </label>

                <textarea
                    name="description"
                    value={form.description}
                    onChange={onChange}
                    placeholder="Add additional information for your client..."
                    rows="4"
                />
            </div>
        </section>
    );
};

export default PaymentDetailsSection;
